/* ATHLETES VariantPicker Guard
   Ziel: verhindert, dass ein VariantPicker-Error das restliche Theme-JS killt
   (z.B. Slideshow/Media Grid Buttons funktionieren sonst nicht mehr)
*/
(function () {
  try {
    var TAG = '[ATHLETES]';
    var VP = window.customElements && window.customElements.get
      ? window.customElements.get('variant-picker')
      : null;

    if (!VP) {
      console.warn(TAG, 'variant-picker custom element not found (yet).');
      return;
    }

    // Nur einmal patchen
    if (VP.prototype.__athletesGuardPatched) {
      console.log(TAG, 'VariantPicker guard already active');
      return;
    }
    VP.prototype.__athletesGuardPatched = true;

    var orig = VP.prototype.connectedCallback;

    VP.prototype.connectedCallback = function () {
      try {
        if (typeof orig === 'function') orig.call(this);
      } catch (err) {
        // Crash verhindern, damit andere Theme-Module (Slideshow etc.) weiterlaufen
        console.error(TAG, 'VariantPicker.connectedCallback prevented crash:', err);

        // Optional: defensiv ein kleines Flag setzen, falls später Code darauf prüft
        this.setAttribute('data-athletes-vp-guarded', 'true');

        // KEIN throw -> sonst crasht wieder alles
      }
    };

    console.log(TAG, 'VariantPicker guard patched');
  } catch (e) {
    // absoluter Fallback, niemals crashen
    console.error('[ATHLETES] guard init failed:', e);
  }
})();
